import { LaunchAdStatus } from "@models/launchAd";
import { CommandGetLaunchAds, type LaunchAdListFilters } from "./commands/cmdGetLaunchAds";
import { CommandUpdateLaunchAdStatus } from "./commands/cmdUpdateLaunchAdStatus";
import { CommandAddLaunchAds } from "./commands/cmdAddLaunchAd";
import { CommandListPolicies } from "./commands/cmdListPolicies";
import { CommandGetLaunch } from "./commands/cmdGetLaunch";
import { CommandLinkLaunchOrganization } from "./commands/cmdLinkLaunchOrganization";
import { CommandSetLaunchAdUtm } from "./commands/cmdSetLaunchAdUtm.ts";
import {
  CommandPreviewCampaignDates,
  CommandSetCampaignDates,
} from "./commands/cmdCampaignDates";

export class LaunchService {
  async getLaunch(launchId: number) {
    const cmd = new CommandGetLaunch();
    return cmd.run(launchId);
  }

  /** What moving a campaign's dates would do, without doing it (MPN-2040). */
  async previewCampaignDates(launchId: number, start: string, end: string) {
    return await new CommandPreviewCampaignDates().run(launchId, start, end)
  }

  /** Set the campaign's dates and everything that follows, as one commit. */
  async setCampaignDates(
    launchId: number, start: string, end: string, followAdGroupIds?: number[], note?: string,
  ) {
    return await new CommandSetCampaignDates().run(
      launchId, start, end, followAdGroupIds, note,
    )
  }

  async linkOrganization(launchId: number, organizationId: number) {
    const cmd = new CommandLinkLaunchOrganization();
    return cmd.run(launchId, organizationId);
  }

  async getLaunchAds(filters: LaunchAdListFilters) {
    const cmd = new CommandGetLaunchAds();
    const results = await cmd.run(filters);
    return results;
  }

  async addLaunchAds(launchId: number, adIds: number[]) {
    const cmd = new CommandAddLaunchAds()
    const results = await cmd.run(launchId, adIds)
    return results
  }

  async updateLaunchAdStatus(launchAdId: number, status: LaunchAdStatus) {
    const cmd = new CommandUpdateLaunchAdStatus()
    const results = await cmd.run(launchAdId, status)
    return results
  }

  /** Flip the UTM toggle for one ad on one campaign (MPN-1536). */
  async setLaunchAdUtm(launchAdId: number, appendUtm: boolean) {
    return new CommandSetLaunchAdUtm().run(launchAdId, appendUtm);
  }

  async listPolicies(launchId: number) {
    const cmd = new CommandListPolicies()
    const results = await cmd.run(launchId)
    return results
  }
}
